import { useState, useEffect, useMemo } from "react";
import SwiperPreview from "./SwiperPreview";
import Image from './../Image';
import { CGalleryProps } from "./index.d";
export * from "./index.d";
import playIcon from 'core/assets/icons/comunity/play.svg';
import { sortGalleryByType } from 'core/utils/helper';

const CGallery = ({className = '', items}: CGalleryProps) => {
  const _items = useMemo(() => (
    sortGalleryByType<CGalleryProps['items'][number]>(items)
  ), [items]);
  const mainImage = useMemo(() => (
    _items[0]
  ), [_items]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  // Disable body scroll when modal is open
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    
    // Clean up: Reset body overflow when component is unmounted or modal is closed
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isModalOpen]);
  
  return (
    <div className={`max-w-xl mx-auto ${className}`}>
      {/* Main Image */}
      <div
        className="relative"
        onClick={() => { setSelectedIndex(0); setIsModalOpen(true); }}
      >
        <Image
          src={mainImage?.thumbnail}
          alt="Main"
          className="w-full rounded-lg object-cover aspect-[328/205]"
        />
        {mainImage?.type === 'video' && (
          <button type="button" className="absolute inset-0 flex items-center justify-center">
            <div className="text-white/80 drop-shadow-lg">
              <img src={playIcon} alt="Play" />
            </div>
          </button>
        )}
      </div>
      
      {/* Thumbnail Gallery */}
      <div className="grid grid-cols-4 gap-[3px] mt-[3px]">
        {_items.slice(1, 5).map((img, index) => (
          <button
            key={index}
            type="button"
            onClick={() => { setSelectedIndex(index + 1); setIsModalOpen(true); }}
            className="relative"
          >
            <Image
              src={img.thumbnail}
              alt="Thumbnail"
              className="w-full aspect-square rounded-lg object-cover"
            />
            {img.type === 'video' && (
              <div className="absolute inset-0 flex items-center justify-center text-white/80">
                <img src={playIcon} alt="Play" className="w-[18px] h-[18px]" />
              </div>
            )}
            {index === 3 && _items.length > 5 && (
              <div className="absolute inset-0 flex items-center justify-center bg-dark rounded-lg bg-opacity-20">
                <div className="w-full aspect-square flex items-center justify-center text-white text-[15px]">
                  +{_items.length - 4}
                </div>
              </div>
            )}
          </button>
        ))}
      </div>

      {/* Modal with Swiper */}
      {isModalOpen && (
        <SwiperPreview
          items={_items}
          selectedIndex={selectedIndex}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
}

export default CGallery

// usage
// import CGallery from "core/components/CGallery";
// import { ITEMS } from "core/components/CGallery/exampleData";

// const MainPage = () => {
//   return (
//     <div>
//       <h1>Main Page</h1>
//       <CGallery className="p-4" items={ITEMS} />
//     </div>
//   );
// }

// export default MainPage;
